import { Component, OnInit } from '@angular/core';
import { AlertsService, BasicComponent, LoanSaleDataService } from '@backoffice-monorepo/commons';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'backoffice-monorepo-loan-presale-import',
  templateUrl: './loan-presale-import.component.html',
  styleUrls: ['./loan-presale-import.component.scss']
})
export class LoanPresaleImportComponent extends BasicComponent implements OnInit {

  loansImportForm: FormGroup;
  fileData?: File;
  fileName?: string;

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private alertService: AlertsService,
    private loanSaleDataService: LoanSaleDataService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.loansImportForm = this.formBuilder.group({
      file: ['', Validators.required],
      markAsPreSold: [false]
    });
  }

  fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
  }

  submitForm() {
    this.loanSaleDataService.addLoansToLoanSaleData(this.fileData, this.loansImportForm.get('markAsPreSold').value)
      .pipe(
        takeUntil(this.$destroy)
      )
      .subscribe(() => {
        this.fileData = null;
        this.loansImportForm.reset();
        this.loansImportForm.get('markAsPreSold').setValue(false);
        this.alertService.notifySuccess(`Loans imported`);
        this.activeModal.close(true);
      }, () => {})
  }
}
